'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Analytics } from '@vercel/analytics/next';
import { SpeedInsights } from '@vercel/speed-insights/next';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { PropsWithChildren, useState } from 'react';
import { Toaster } from 'sonner';
import { queryClientConfig } from '@/lib/query-client';
export const AppProviders = ({
  children
}: PropsWithChildren) => {
  const [queryClient] = useState(() => new QueryClient(queryClientConfig));
  return <>
      <NuqsAdapter data-sentry-element="NuqsAdapter" data-sentry-source-file="providers.tsx">
        <QueryClientProvider client={queryClient} data-sentry-element="QueryClientProvider" data-sentry-source-file="providers.tsx">
          {children}
        </QueryClientProvider>
      </NuqsAdapter>
      <Toaster position="top-center" richColors data-sentry-element="Toaster" data-sentry-source-file="providers.tsx" />
      <Analytics data-sentry-element="Analytics" data-sentry-source-file="providers.tsx" />
      <SpeedInsights data-sentry-element="SpeedInsights" data-sentry-source-file="providers.tsx" />
    </>;
};